// src/components/PageHeaderCard.js

import React from "react";
import "./PageHeader.css";

export default function PageHeaderCard({ title, subtitle, actions }) {
  return (
    <div className="ph-card">
      <div className="ph-left">
        <h1 className="ph-title">{title}</h1>
        {subtitle && <p className="ph-subtitle">{subtitle}</p>}
      </div>



      {actions && (
        <div className="ph-actions">
          {actions}
        </div>
      )}
    </div>
  );
}
